import { render, staticRenderFns } from "./FormCreateFromtreatment.vue?vue&type=template&id=19e0f6b9&"
import script from "./FormCreateFromtreatment.vue?vue&type=script&lang=js&"
export * from "./FormCreateFromtreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports